import axios from "axios";
const jsonConfig = require("../../Config.json");
 
const candidateownershiptransfer = async (payload) => {
    try {
        const response = await axios.post(
    jsonConfig.apiUrl + "candidateownershiptransfer",payload,
      {
        headers: {
          "x-functions-key": jsonConfig.key,
        },
      }
    );
    return Promise.resolve(response);
  } catch (error) {
    return Promise.reject(error);
  }
}
 
export default candidateownershiptransfer;
 